// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  mutation createInviteUrl($id: String!) {
    createInviteUrl(id: $id) {
      success
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Mutations/createInviteUrl.js